import React from "react";
import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

interface DiscardRoleChangesDialogProps {
  isOpen: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

/** Asks before leaving the role form with unsaved changes. */
export default function DiscardRoleChangesDialog({
  isOpen,
  onKeepEditing,
  onDiscard,
}: DiscardRoleChangesDialogProps) {
  const { l10n } = useLocalization();

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={onKeepEditing}
      title={l10n.getString("org-role-discard-dialog-title")}
      width="500px"
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button
              kind="negative"
              label={l10n.getString("org-role-discard-dialog-keep-editing")}
              onClick={onKeepEditing}
              testId="discard-role-dialog-keep-editing"
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              label={l10n.getString("org-role-discard-dialog-confirm")}
              onClick={onDiscard}
              testId="discard-role-dialog-confirm"
            />
          </Row.Item>
        </Row>
      }
    >
      <p>{l10n.getString("org-role-discard-dialog-body")}</p>
    </Dialog>
  );
}
